export default "/images/vendor/flag-icons/flags/1x1/ml.svg?abd95c9bbc3b8e14d05ad233d4c79580";